export default __webpack_public_path__ + "static/med-spa-75cc7a3b71c49c434a2929d041edcd6a.png";